import { styled } from '@linaria/react';
import { Flex } from '@mantine/core';
import { Checkbox } from '../../../../../ui-library/checkbox/checkbox';
import { Text } from '../../../../../ui-library/typography/typography';

interface Props {
  value: string;
  label: string | null;
  color: string;
  isHovered?: boolean;
  isChecked: boolean;
  onMouseEnter?: (itemId: string) => void;
  onMouseLeave?: () => void;
  onToggle: (itemId: string) => void;
}

export const LineChartLegendItemWithCheckbox = ({
  value,
  label,
  color,
  isHovered,
  isChecked,
  onMouseEnter,
  onMouseLeave,
  onToggle,
}: Props) => {
  return (
    <Flex
      key={value}
      align="center"
      gap={8}
      style={{
        cursor: 'pointer',
        opacity: isHovered === undefined ? 1 : isHovered ? 1 : 0.3,
        transition: 'opacity 0.2s ease',
      }}
      onMouseEnter={() => onMouseEnter?.(value)}
      onMouseLeave={() => onMouseLeave?.()}
      onClick={(e) => {
        e.stopPropagation();
        onToggle(value);
      }}
    >
      <Checkbox checked={isChecked} readOnly />
      <Label color={color}>
        <Text size="small" lineHeight="none">
          {label}
        </Text>
      </Label>
    </Flex>
  );
};

export const Label = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: '';
    min-width: 10px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${(props) => props.color};
  }
`;
